import React, { useContext, useEffect, useState } from 'react';
import { EventContext } from '../context/EventContext';
import { UserRoleContext } from '../context/UserRoleContext';
import EventCard from './EventCard';
import { getEvents, getEventsByHostId } from '../services/eventService';
import { Event } from '../types/Event';
import EventTable from './EventTable';

const EventSelect: React.FC = () => {
    const { currentEvent, setCurrentEvent } = useContext(EventContext); // Assuming the event data is in context
    const { userRole } = useContext(UserRoleContext);
    const [hostEvents, setHostEvents] = useState<Event[]>([]); // Store events fetched by hostId
    const [orgEvents, setOrgEvents] = useState<Event[]>([]); // Store events fetched by hostId
    const [allEvents, setAllEvents] = useState<Event[]>([]); // Store events fetched by hostId

    // Fetch events for the host when component mounts or userRole changes
    useEffect(() => {
        const fetchHostEvents = async () => {
            if (userRole?.host_id) {
                try {
                    const fetchedEvents = await getEventsByHostId(userRole?.host_id);//getEventsByHostId(userRole.host_id || currentEvent.host_id); // Fetch events by host
                    setHostEvents(fetchedEvents); // Update state with fetched events
                } catch (error) {
                    console.error("Error fetching events:", error);
                }
            }
        };

        // const fetchOrgEvents = async () => {
        //     if (userRole?.organization_id || currentEvent) {
        //         try {
        //             const fetchedEvents = await getEventsByOrg();//getEventsByHostId(userRole.host_id || currentEvent.host_id); // Fetch events by host
        //             console.log("fix to org events");
        //             setOrgEvents(fetchedEvents); // Update state with fetched events
        //         } catch (error) {
        //             console.error("Error fetching events:", error);
        //         }
        //     }
        // };

        const fetchAllEvents = async () => {
            //if (userRole?.host_id || currentEvent) {
                try {
                    const fetchedEvents = await getEvents();//getEventsByHostId(userRole.host_id || currentEvent.host_id); // Fetch events by host
                    setAllEvents(fetchedEvents); // Update state with fetched events
                } catch (error) {
                    console.error("Error fetching events:", error);
                }
            //}
        };
        fetchHostEvents();
        //fetchOrgEvents();
        fetchAllEvents();
    }, [userRole?.host_id, currentEvent?.host_id]); // Re-run the effect when host_id changes

    // Handle event selection (for example, to view more details or navigate somewhere)
    const handleEventSelect = (event: Event) => {
        if (currentEvent) {
        if (currentEvent.event_id == event.event_id) {
            setCurrentEvent(null);
        } else {
            setCurrentEvent(event);
        }
        } else {
        setCurrentEvent(event);
        }
    };

    // Render event cards horizontally
    const renderEventSelect = () => {
        return (
            <div>
                {(userRole?.host_id || currentEvent?.host_name) && (<div>
                    <h3>Events From {userRole?.host_name || currentEvent?.host_name}</h3>
                    <div style={styles.cardContainer}>
                        {hostEvents && hostEvents.length > 0 ? (
                            hostEvents.map((event) => (
                                <EventCard key={event.event_id} event={event} onSelectEvent={handleEventSelect} />
                            ))
                        ) : (
                            <p>No events found</p>
                        )}
                    </div>
                </div>)}
                {(userRole?.organization_id) && (<div>
                    <h3>{userRole?.organization_name}'s Attending Events</h3>
                    <div style={styles.cardContainer}>
                        {orgEvents && orgEvents.length > 0 ? (
                            orgEvents.map((event) => (
                                <EventCard key={event.event_id} event={event} onSelectEvent={handleEventSelect} />
                            ))
                        ) : (
                            <p>No events found</p>
                        )}
                    </div>
                </div>)}


                <h3>All Events You're A Part Of</h3>
                {/* <div style={styles.cardContainer}>
                    {allEvents && allEvents.length > 0 ? (
                        allEvents.map((event) => (
                            <EventCard key={event.event_id} event={event} onSelectEvent={handleEventSelect} />
                        ))
                    ) : (
                        <p>No events found</p>
                    )}
                </div> */}
                
                {allEvents && allEvents.length > 0 ? (
                        <EventTable allEvents={allEvents} />
                    ) : (
                        <p>No events found</p>
                    )}
            </div>

        );
    };

    return (
        <div style={styles.container}>
            <h1>Select an Event</h1>
            {renderEventSelect()}
        </div>
    );
};

// Example styles (adjust to your design)
const styles = {
    container: {
        //padding: '20px',
    },
    cardContainer: {
        display: 'flex',
        gap: '20px',
        width: '100%',
        overflowX: 'auto',        
    } as React.CSSProperties,
    noEventContainer: {
        padding: '20px',
        backgroundColor: '#e0e0e0',
        borderRadius: '8px',
    },
    button: {
        display: 'inline-block',
        backgroundColor: '#3498db',
        color: '#fff',
        padding: '10px 20px',
        textDecoration: 'none',
        borderRadius: '4px',
        marginTop: '20px',
        fontSize: '16px',
    },
};

export default EventSelect;
